export default {
  "home": "HOME",
  "news": "NEWS",
  "community": "COMMUNITY",
  "character": "CHARACTERS",
  "world": "WORLD",
  "features": "FEATURES",
  "topUp": "TOP UP",
  "customerService": "CUSTOMER",
  "download": "DOWNLOAD",
  "moreDownload": "More download methods",
  "screenshot": "SCREENSHOT",
  "video": "CINEMATIC",
  "poster": "POSTER",
  "downloadGame": "DOWNLOAD",
  "scan": "Scan QR code to download",
  "prev": "Previous",
  "next": "Next",
  "latest": "Latest",
  "fwtk": "TERMS OF SERVICE",
  "yszc": "PRIVACY POLICY",
  "noContent": "No content yet",
  "goPay": "GO NOW",
  "payGuide": "LEARN MORE",
  "stayTurn": "Stay tuned!",
  "back": "Back",
}
